import { NexcarExpedient } from "../interfaces/purchase-order.interface";

/**
 * Nexcar hosts the report on its side, not in our storage, so the documents download endpoint
 * cannot stream it. Its public URL travels inside the expedient payloads (`urlNexcarReport`), which is
 * what the viewers must embed instead of downloading by document id.
 */
export function getNexcarReportPublicUrl(expedient: NexcarExpedient | null | undefined): string | null {
  if (!expedient) {
    return null;
  }
  for (const payload of [expedient.response_payload, expedient.webhook_payload]) {
    const record = coercePayloadToRecord(payload);
    if (!record) {
      continue;
    }
    const direct = record["urlNexcarReport"];
    if (typeof direct === "string" && direct.trim().length > 0) {
      return direct.trim();
    }
    const nested = findUrlNexcarReportRecursive(record);
    if (nested) {
      return nested;
    }
  }
  return null;
}

function findUrlNexcarReportRecursive(node: Record<string, unknown>, depth = 0): string | null {
  if (depth > 8) {
    return null;
  }
  for (const [key, value] of Object.entries(node)) {
    if (key === "urlNexcarReport" && typeof value === "string" && value.trim().length > 0) {
      return value.trim();
    }
    if (value && typeof value === "object" && !Array.isArray(value)) {
      const found = findUrlNexcarReportRecursive(value as Record<string, unknown>, depth + 1);
      if (found) {
        return found;
      }
    }
  }
  return null;
}

/** Older expedients persisted the payloads as JSON strings, so both shapes are accepted. */
function coercePayloadToRecord(payload: unknown): Record<string, unknown> | null {
  if (payload == null) {
    return null;
  }
  if (typeof payload === "string") {
    try {
      const parsed = JSON.parse(payload) as unknown;
      return parsed !== null && typeof parsed === "object" ? (parsed as Record<string, unknown>) : null;
    } catch {
      return null;
    }
  }
  if (typeof payload === "object") {
    return payload as Record<string, unknown>;
  }
  return null;
}
